
    <app-card [isHeader]=true [title]="'search_filter'|translate">


<form (ngSubmit)="submit()" [formGroup]="form" >
  <div class="cp5" fxLayout="row wrap" fxLayoutAlign="start center">
        
      <div fxFlex="25" fxFlex.lt-md="100">
          <app-text-field
          [control]="getFormControl('planNo')"
          [label]="labels.planNo | translate"
        ></app-text-field>
      </div>
    <div fxFlex="25" fxFlex.lt-md="100">
        <!-- <app-text-field
          [control]="getFormControl('planYear')"
          [label]="labels.planYear | translate"
        ></app-text-field> -->
        <app-combo-years  [control]="getFormControl('planYear')" [withfiltre]="false"
        [label]="labels.planYear" ></app-combo-years>
        
      </div>
      <div  fxFlex="25" fxFlex.lt-md="100">
          <app-combo-acheteur [control]="getFormControl('instNm')" [label]="labels.instNm | translate"></app-combo-acheteur>  
        </div>
    
        <div fxFlex="25" fxFlex.lt-md="100">
          <app-text-field
            [control]="getFormControl('planNmFr')"
            [label]="labels.planNmFr | translate"
          ></app-text-field>
        </div>
</div>
    <div 
    fxflex="100" class="cp5" fxLayout="row wrap" fxLayoutAlign="start center"
    *ngIf="panelOpenState">
    <div  fxFlex="50" fxFlex.lt-md="100" >
      
      <app-combo-commande [control]="getFormControl('pbkStrFr')"  [controlFils]="getFormControl('bizKindNmFr')" 
      [label]="labels.pbkStrFr | translate"  [code]="commmCode.categorieActivite"></app-combo-commande>
    </div>

    <div fxFlex fxFlex="25" fxFlex.lt-md="100">
        <app-select-common [withcommonid]="true" [control]="getFormControl('financialMethodStrFr')" [withfiltre]="true"
        [label]="labels.financialMethodStrFr"  [code]="commmCode.financement"></app-select-common>
    </div>
    <div fxFlex fxFlex="25" fxFlex.lt-md="100">
    <app-select-common [withcommonid]="true" [control]="getFormControl('executionPlaceStrFr')" [withfiltre]="true"
    [label]="labels.executionPlaceStrFr"  [code]="commmCode.lieu"></app-select-common>
    
    <!-- <app-select-common [control]="getFormControl('smallBizYn')" [withfiltre]="true"
    [label]="labels.smallBizYn | translate"  [code]="commmCode.smallBizYn"></app-select-common> -->
  </div>
  <!-- <div fxFlex fxFlex="25" fxFlex.lt-md="100">
    <app-select-common [control]="getFormControl('smallBizYn')" [withfiltre]="true"
    [label]="labels.smallBizYn | translate"  [code]="commmCode.smallBizYn"></app-select-common>     
</div> -->
    <div fxFlex fxFlex="25" fxFlex.lt-md="100">
      <app-select-date
        [control]="getFormControl('publicDt')"
        label="aprés cette date publication"
      ></app-select-date>
      
    </div>
    <div fxFlex fxFlex="25" fxFlex.lt-md="100">
      <app-select-date
        [control]="getFormControl('publicDt_end')"
        label="avant cette date publication"
      ></app-select-date>
      
    </div>

    <div fxFlex fxFlex="25" fxFlex.lt-md="100">
      <app-select-date
        [control]="getFormControl('bidExecutionExpDt')"
        label="Date prévue début exécution (Après)"
      ></app-select-date>
      
    </div>
    <div fxFlex fxFlex="25" fxFlex.lt-md="100">
      <app-select-date
        [control]="getFormControl('bidExecutionExpDt_end')"
        label="Date prévue début exécution (Avant)"
      ></app-select-date>
      
    </div>

    <div fxFlex="25" fxFlex.lt-md="100">
      <app-combo-pme  [control]="getFormControl('smallBizYn')" [withfiltre]="false"
      [label]="labels.smallBizYn" ></app-combo-pme>
      
    </div>
 
  </div>
    <div  fxLayoutAlign="end end">
      <div>
          <button
            class="filter-btn"
            style="background-color: #3498db;"
            color="primary"
            mat-flat-button
            type="submit"
          >
            <mat-icon>{{ icons.search }}</mat-icon>
            <span translate>search</span>
          </button>
        </div>
        <div style="margin-left: 1%;margin-right: 1%;">
          <button
          class="filter-btn"
            color="primary"
            mat-flat-button
            type="submit"
            (click)="reset()"
           
           
          >
            <mat-icon>{{ icons.reset }}</mat-icon>
            <span translate>reset</span>
          </button>
        </div>
        <div>
          <a  class="filter-btn"
          style="background-color: #FFFFFF;
          "
          mat-flat-button
           *ngIf="panelOpenState==true" (click)="panelOpenState=!panelOpenState"  ><mat-icon>remove_circle_outline</mat-icon></a>
          <a  
          class="filter-btn"
          style="background-color: #FFFFFF;
          "
          mat-flat-button
          *ngIf="panelOpenState==false" (click)="panelOpenState=!panelOpenState"  ><mat-icon>add_circle_outline</mat-icon></a>
        </div>
      </div>
  
   
    
    </form>
  
  </app-card>